module.exports = __webpack_public_path__ + "restrictions-icon.png?32c833dd3d0fa53c2a6596a1f6aecc2e";